export type DevstroupeDrawerMode =
    | 'over'
    | 'side';

export type DevstroupeDrawerPosition =
    | 'left'
    | 'right';
